<template>
  <v-card class="mt-2">
    <v-card-title>決済用CD設定</v-card-title>
    <v-card-actions>
      <v-btn @click="addExpenseCode()">行追加</v-btn>
      <v-btn :disabled="codeSelected.length !== 1" @click="editExpenseCode()"
        >編集</v-btn
      >
      <v-btn :disabled="codeSelected.length === 0" @click="remove()"
        >削除</v-btn
      >
    </v-card-actions>
    <v-data-table
      :headers="codeHeaders"
      :items="expenseCodes"
      :rows-per-page-items="[-1]"
      class="inline-edit"
      item-key="code"
      select-all
      v-model="codeSelected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox
            hide-details
            primary
            v-model="props.selected"
          ></v-checkbox>
        </td>
        <td>{{ props.item.code }}</td>
        <td>{{ props.item.name }}</td>
      </template>
    </v-data-table>
    <add-expense-code-dialog
      :expenseCodes="expenseCodes"
      @refresh="load()"
      @addTempExpenseCode="addTempExpenseCode"
      :company="company"
      ref="expenseCode"
    ></add-expense-code-dialog>
  </v-card>
</template>

<script>
import AddExpenseCodeDialog from "./AddExpenseCodeDialog.vue";

export default {
  components: {
    AddExpenseCodeDialog,
  },
  props: ["company"],
  data() {
    return {
      codeSelected: [],
      codeHeaders: [
        {
          text: "決済用CD",
          sortable: false,
        },
        {
          text: "決済用CD名称",
          sortable: false,
        },
      ],
      expenseCodes: [],
    };
  },
  methods: {
    load() {
      if (this.company) {
        this.$http
          .get(`expense-codes/company/${this.company.companyId}/code`)
          .then((res) => {
            this.expenseCodes = res.data;
            this.codeSelected = [];
          });
      }
    },
    addTempExpenseCode(tempExpenseCode) {
      this.expenseCodes.push(tempExpenseCode);
    },
    addExpenseCode() {
      this.$refs.expenseCode.popup("NEW", {});
    },
    editExpenseCode() {
      this.$refs.expenseCode.popup("EDIT", this.codeSelected[0]);
    },
    remove() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        if (!this.company.companyId) {
          this.codeSelected.forEach((cs) => {
            var index = this.expenseCodes.indexOf(cs);
            if (index > -1) {
              this.expenseCodes.splice(index, 1);
            }
          });
          this.codeSelected = [];
          return;
        }
        Promise.all(
          this.codeSelected.map((s) => {
            return this.$http.delete(`/expense-codes/code/${s.code}`);
          })
        )
          .then(() => {
            this.load();
            this.$message("", "経理コード削除しました。");
          })
          .catch((err) => {
            this.$message("", "経理コード削除失敗しました。");
          });
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
